<template>
  <div class="item-selector-container">
    <div class="item-selector-header d-flex justify-content-between px-3">
      <span class="name">{{ groupName }}</span>
      <div class="text-end">
        <sc-button
          v-if="!isAffectApp && !deletedAt"
          variant="danger"
          @click="handleCancelGroup"
          >ยกเลิกกรุ๊ป</sc-button
        >
        <sc-button
          v-if="!deletedAt"
          variant="primary"
          @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
    </div>
    <div :class="classList" class="item-selector">
      <searchable-item-list
        v-if="showSearchList"
        :query="query"
        :is-loading="isLoading"
        :value="selectableItems"
        class="search-list"
        @queryChange="handleQueryChange"
        @select="handleSelectItem"
      ></searchable-item-list>
      <selected-item-list
        :disabled="disabled"
        :deleted-at="deletedAt"
        :value="value"
        class="selected-list"
        @remove="handleRemoveItem"
        @removeAll="handleRemoveAllItem"
      ></selected-item-list>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";

import ScButton from "@/lib/components/ScButton";
import { debounce } from "@/lib/util";

import differenceWith from "ramda/src/differenceWith";

import SearchableItemList from "./SearchableItemList";
import SelectedItemList from "./SelectedItemList";

function compareItem(item, item2) {
  return item.id === item2.id;
}

export default {
  components: {
    SelectedItemList,
    SearchableItemList,
    ScButton
  },
  props: {
    allItem: { type: Array, default: () => [] },
    groupName: { type: String, default: "" },
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    isAffectApp: { type: Boolean, default: false },
    deletedAt: { type: [String, Date], default: null }
  },
  data() {
    return {
      query: "",
      isLoading: false
    };
  },
  computed: {
    selectableItems() {
      const allItem = this.allItem ? this.allItem : [];

      return differenceWith(compareItem, allItem, this.value);
    },
    showSearchList() {
      return !this.disabled && !this.deletedAt;
    },
    classList() {
      return { disabled: this.disabled };
    }
  },
  watch: {
    query() {
      this.watchQuery();
    }
  },
  methods: {
    handleSelectItem(itemId) {
      this.$emit("selectedItem", itemId);
    },
    handleRemoveItem(itemId) {
      this.$emit("removedItem", itemId);
    },
    async handleRemoveAllItem() {
      try {
        await MessageBox.confirm("คุณต้องการลบทุกรายการใช่หรือไม่", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก"
        });
      } catch (e) {
        return;
      }

      this.$emit("removedAllItem");
    },
    handleQueryChange(value) {
      this.query = value;
    },
    handleClickSave() {
      this.$emit("updateGroup");
    },
    handleCancelGroup() {
      this.$emit("cancelGroup");
    },
    watchQuery: debounce(function watchQuery() {
      this.$emit("searchItem", this.query);
    }, 1.5)
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.item-selector-container {
  background: white;
  padding: 0;
  max-height: 100%;
}

.item-selector-header {
  border-bottom: 1px solid #e0e0e0;
  padding: 13px;
}

.name {
  font-size: 23px;
  font-weight: bold;
}

.item-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: calc(100% - 65px);

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.item-selector.disabled {
  display: block;

  > .selected-list {
    border-left-width: 1px;
    border-radius: $border-radius;
  }
}
</style>
